import React, { Component } from 'react';
import './Footer.css';

//Helpers
import { Link } from 'react-router-dom';

//Assets
import Logo from './Assets/logo/logolight';

export default class Footer extends Component {

  openIntercom(e) {
    e.preventDefault();
    window.Intercom('showNewMessage');
  }

  render() {
    return (
      <footer>
        <div className="footer wide-container">
          <div className="columns">
            <div className="logo-column column">
              <Link className="logo" to="/"><Logo/></Link>
              <p>Copyright 2020 SwiftLab Ltd. All rights reserved.</p>
            </div>
          </div>
          </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Footer.js